import {FirestoreDataConverter} from "firebase/firestore";
import {RRFuelInvoiceType} from "../../types/RRFuelInvoiceType";

export const fuelInvoiceConverter: FirestoreDataConverter<RRFuelInvoiceType> = {
    toFirestore: (invoice: RRFuelInvoiceType) => ({
        driverId: invoice.driverId,
        truckId: invoice.truckId,
        invNumber: invoice.invNumber,
        invDate: invoice.invDate,
        price: invoice.price,
        fuelAmount: invoice.fuelAmount,
        startKm: invoice.startKm,
        endKm: invoice.endKm,
        avgPriceForKm: invoice.avgPriceForKm,
        totalKm: invoice.totalKm,
        notes: invoice.notes || ""
    }),
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        return {
            id: snapshot.id,
            driverId: data.driverId || "",
            truckId: data.truckId || "",
            invNumber: data.invNumber || "",
            invDate: data.invDate?.toDate ? data.invDate.toDate() : data.invDate,
            price: data.price || 0,
            fuelAmount: data.fuelAmount || 0,
            startKm: data.startKm || 0,
            endKm: data.endKm || 0,
            // calculate avg price per km from invoice if available: total cost / totalKm
            avgPriceForKm: data.totalKm ? ((data.fuelAmount || 0) * (data.price || 0)) / (data.totalKm || 1) : 0,
            totalKm: data.totalKm || 0,
            notes: data.notes || "",
        };
    }
};
